/**
 * Builds URL query string from recipe filters, applying defaults when needed.
 * @param filters - Optional filters to apply (defaults to fetchPreferred=true)
 * @returns Query string (with leading '?') or empty string if no params
 */
export const toQueryParams = (filters) => {
    const params = [];
    let hasFetchPreferred = false;
    if (filters?.where) {
        for (const filter of filters.where) {
            switch (filter.field) {
                case "loadBoolExpr": {
                    if (typeof filter.value === "boolean") {
                        params.push(`loadBoolExpr=${filter.value}`);
                    }
                    break;
                }
                case "fetchPreferred": {
                    if (typeof filter.value === "boolean") {
                        params.push(`fetchPreferred=${filter.value}`);
                        hasFetchPreferred = true;
                    }
                    break;
                }
                case "id": {
                    // ID filters are handled separately via parseIdFilter in index.ts
                    break;
                }
            }
        }
    }
    // Default to fetchPreferred=true
    if (!hasFetchPreferred) {
        params.push("fetchPreferred=true");
    }
    // If loadBoolExpr is not explicitly set, don't add it to query params
    // (let the backend use its default behavior)
    return params.length > 0 ? `?${params.join("&")}` : "";
};
//# sourceMappingURL=filters.js.map